import { render, staticRenderFns } from "./MisAOCs.vue?vue&type=template&id=2efdcfc6&scoped=true&"
import script from "./MisAOCs.vue?vue&type=script&lang=js&"
export * from "./MisAOCs.vue?vue&type=script&lang=js&"
import style0 from "./MisAOCs.vue?vue&type=style&index=0&id=2efdcfc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efdcfc6",
  null
  
)

export default component.exports